module.exports = "../study/imgs/maps/Kanagawa/S8/Helth/HeatStress/Kanagawa_HeatStress_GFDL_RCP85_Mid.png";